<template>
  <div>
    <div class="logo">
      <img v-if="client.logo"
           :src="`/uploads/${client.logo}`" alt="">
    </div>
  </div>
</template>
<script>
export default {
  props: ['client']
}
</script>
<!--
<style lang="stylus">
  .logo
    position fixed
    top 0
    left 0
    width 100vw
    height 100vh
    display flex
    align-items center
    justify-content center

    img
      width 90%
      max-width 800px
</style>
 -->